const ExclamationMarkCircleOutlinedIcon = (props: any) => {
  const {
    insideFill,
    circleFill = '#FFF3E5',
    fill = '#344054',
    stroke,
    ...otherProps
  } = props;
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...otherProps}
    >
      <g id='Exclaimation point'>
        <path
          id='Vector'
          d='M12 7.5V12.5M12 15V15.5M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z'
          stroke={stroke ?? '#F53131'}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  );
};

export default ExclamationMarkCircleOutlinedIcon;
